import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.04 19.88l-.23-.14C27.76 19.13 26 18.11 26 14V6a2 2 0 00-2-2H4a2 2 0 00-2 2v20a2 2 0 002 2h20a2 2 0 002-2v-2h2a2 2 0 002-2v-.42a1.97 1.97 0 00-.96-1.7zM24 26H4v-4.92a9.44 9.44 0 003.63 2.85A.94.94 0 008 24h16zm4-4H8.21A7.59 7.59 0 014 15V6h20v8c0 3.22.96 5.03 2 6.11a7.49 7.49 0 001.8 1.36l.2.11z"/><path d="M18 13h-3v-3a1 1 0 00-2 0v3h-3a1 1 0 000 2h3v3a1 1 0 002 0v-3h3a1 1 0 000-2z"/>';
export var NoteAddOutlineSVG = function NoteAddOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
NoteAddOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(NoteAddOutlineSVG);